import { selectMember, selectSubscriptionHasStarted } from 'logic/member';
import { selectProduct, selectWeeks } from 'logic/product';
import { selectCompletions } from 'logic/completions';

export const ProgramNav = {
  template: `
    <nav class="program-nav">
      <div class="container arrow-row-container">
        <div class="row nav-scroll-wrapper">
          <div class="nav-scroll-content">
            <div class="content-row">
              <div class="d-table px-3 py-3 bg-teal-dark">
                <div class="d-table-cell">
                  <div class="modal-toggle">
                    <button
                      class="btn btn-pill btn-sm theme-btn"
                      data-toggle="modal"
                      data-target="#modalStartProgram"
                      ng-if="!$ctrl.hasStarted || ($ctrl.program.daysElapsed < 0)">
                      <span class="text-uppercase font-weight-bold">
                        Start
                        <span ng-if="$ctrl.program.daysElapsed < 0">now</span>
                      </span>
                    </button>
                    <button-link
                      data-toggle="modal"
                      data-target="#modalRestartProgram"
                      ng-if="$ctrl.hasStarted && ($ctrl.program.daysElapsed >= 0)">
                      <span class="text-white">Restart?</span>
                    </button-link>
                  </div>
                </div>
                <div class="d-table-cell nav-progress-row">
                  <div class="nav-progress-wrapper">
                    <progress-bar
                      weeks="$ctrl.weeks"
                      percentage="$ctrl.program.percentElapsed"
                      img-src="$ctrl.member.profile.avatarUrl.thumb">
                    </progress-bar>
                  </div>
                </div>
              </div>
            </div>
            <div class="content-row nav-week-tiles">
              <a class="week-tile-wrapper pl-3 bg-teal-dark"
                ui-sref="program.intro({ voomeProductId: $ctrl.program.id })"
                ui-sref-active="active">
                <div class="nav-tile nav-tile--intro">
                  <span class="theme-border-hover"></span>
                  <div class="nav-tile-content">
                    <span class="theme-program-logo w-100 h-100 mx-3">
                      <span>{{ $ctrl.program.name }}</span>
                    </span>
                  </div>
                </div>
                <box-arrow-row></box-arrow-row>
              </a>
              <a class="week-tile-wrapper bg-teal-dark"
                ng-repeat="week in $ctrl.weeks track by $index"
                ng-class="{ 'active': $ctrl.weekNumber === week.weekNumber }"
                ui-sref="program.week.detail({ weekNumber: week.weekNumber })">
                <div class="nav-tile">
                  <span class="theme-border-hover"></span>
                  <div class="nav-tile-content"
                    style="background-image: url('{{ week.introVideo.thumbnailUrl.magazine | assetSrc }}')">
                    <progress-badge
                      count="$ctrl.completions[week.weekNumber].total"
                      total="week.workouts.length + week.mealPlan.daysCount"
                      number="week.weekNumber">
                    </progress-badge>
                    <div class="nav-tile-title">
                      <span>{{ week.title }}</span>
                    </div>
                  </div>
                </div>
                <box-arrow-row></box-arrow-row>
              </a>
              <a class="week-tile-wrapper last-tile pr-3 bg-teal-dark"
                ng-class="{ 'disabled' : !$ctrl.program.isGraduated }"
                ui-sref="program.graduation"
                ui-sref-active="active">
                <div class="nav-tile nav-tile--graduation">
                  <span class="theme-border-hover"></span>
                  <div class="nav-tile-content">
                    <i class="fa fa-trophy"></i>
                  </div>
                </div>
                <box-arrow-row></box-arrow-row>
              </a>
            </div>
          </div>
        </div>
      </div>
    </nav>`,

  controller($ngRedux) {
    'ngInject';

    return {
      $onInit() {
        const connect = $ngRedux.connect(this.mapState, {});
        this.disconnect = connect(this);
      },

      $onDestroy() {
        this.disconnect();
      },

      mapState(state) {
        const { member, product, router } = state;
        const { voomeProductId, weekNumber } = router.currentParams;

        return {
          weekNumber,
          completions: selectCompletions(state, weekNumber),
          hasStarted: selectSubscriptionHasStarted(member, voomeProductId),
          member: selectMember(member),
          program: selectProduct(product),
          weeks: selectWeeks(product),
        };
      },
    };
  },
};



// WEBPACK FOOTER //
// ./src/containers/Program/Nav.js